document.querySelectorAll('.tab-link').forEach(tab => {
  tab.addEventListener('click', () => {
    const parent = tab.closest('.product-tabs');
    const tabId = tab.getAttribute('data-tab');

    // Rimuovi classe active da tutti i bottoni e contenuti
    parent.querySelectorAll('.tab-link').forEach(t => t.classList.remove('active'));
    parent.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    // Aggiungi classe active a quello cliccato
    tab.classList.add('active');
    document.getElementById(tabId).classList.add('active');
  });
});